import {
  UT_FAILURE,
  UT_PENDING,
  UT_SUCCESS,
  UST_FAILURE,
  UST_PENDING,
  UST_SUCCESS,
} from './constants'
import {getUserTemplateRulesAndUser as getUserTemplateRulesAndUserApi} from '../../../services/user'

export async function getUserTemplate(dispatch) {
  try {
    dispatch({type: UT_PENDING})
    const response = await getUserTemplateRulesAndUserApi()
    dispatch({type: UT_SUCCESS, payload: response})
  } catch (e) {
    console.log(`Get User Templates Rules and User Failed: ${e}`)
    dispatch({type: UT_FAILURE, payload: e})
  }
}

export async function getSearchTemplate(search, dispatch) {
  try {
    dispatch({type: UST_PENDING})
    const response = await getUserTemplateRulesAndUserApi(search)
    dispatch({type: UST_SUCCESS, payload: response})
    return true
  } catch (e) {
    console.log(`Get User Templates Rules and User Failed: ${e}`)
    dispatch({type: UST_FAILURE, payload: e})
    return true
  }
}
